var map = {
	"./bmp": 801,
	"./bmp.js": 801,
	"./gif": 802,
	"./gif.js": 802,
	"./jpg": 803,
	"./jpg.js": 803,
	"./png": 804,
	"./png.js": 804,
	"./psd": 805,
	"./psd.js": 805,
	"./svg": 806,
	"./svg.js": 806,
	"./tiff": 807,
	"./tiff.js": 807,
	"./webp": 808,
	"./webp.js": 808
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 799
// module chunks = 1